// File: src/pages/PageNotFound.jsx

import React from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Stack,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Home, ArrowBack, DescriptionOutlined } from "@mui/icons-material";
import HomepageHeader from "../../components/UI/organisms/header/Header"

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ backgroundColor: "#fdf9f3", minHeight: "100vh" }}>
      <HomepageHeader/>

    <Box
      sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: {
            xs: "120px 8px 8px 8px",
            sm: "120px 24px 24px 24px",
            md: "120px 24px 24px 24px",
            lg: "120px 24px 24px 24px",
            xl: "120px 24px 24px 24px",
          },
          pt: 15,
        }}
    >
      <Paper
        elevation={1}
        sx={{
          maxWidth: 500,
          width: "100%",
          textAlign: "center",
          p: {
            xs: "40px 10px",
            sm: "40px 5px",
            md: "40px",
            lg: "40px",
            xl: "40px",
          },
          borderRadius: 2,
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            bgcolor: "rgba(201, 167, 107, 0.15)",
            width: 70,
            height: 70,
            borderRadius: "50%",
            mx: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <DescriptionOutlined sx={{ color: "#C9A76B", fontSize: 36 }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", color: "#3B2F1E", mb: 1 }}
        >
          404 - Page Not Found
        </Typography>

        {/* Message */}
        <Typography
          variant="body2"
          sx={{ 
            color: "#4F4A43",
            mb: 4, 
            px: 3,
            lineHeight: 1.6
          }}
        >
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </Typography>

        {/* Buttons */}
        <Stack
          direction={
            {xs: "column", 
            sm: "row", 
            md: "row", 
            lg: "row", 
            xl: "row"
            }}
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
            sx={{
              textTransform: "none",
              borderColor: "#C9A76B",
              color: "#4F4A43",
              "&:hover": {
                bgcolor: "rgba(201, 167, 107, 0.1)",
                borderColor: "#C9A76B",
              },
              px: 2.5,
            }}
          >
            Go Back
          </Button>
        </Stack>
      </Paper>
    </Box>
    </Box>
  );
}

export default PageNotFound;